import { ConnectStores } from "lib/core/store"
import { DESIGN, LEARN, TEACH } from "path/constants"

export const getAvailableModes = ({
  permissions,
  offering,
  registration,
  viewing_as_learner
}) => {
  if (!permissions || !offering || viewing_as_learner) {
    return []
  }

  if (permissions.can_edit_path) {
    // only DESIGN mode allowed on source cohort
    if (offering.is_curriculum) {
      return [DESIGN]
    }
    // include LEARN mode for admin, library editor, course editor who is registered as an observer, learner, or moderator
    if (registration && registration.role <= 10) {
      return [DESIGN, TEACH, LEARN] // <PathModeControls /> depends on order ... great design I know
    }
    return [DESIGN, TEACH] // <PathModeControls /> depends on order ... great design I know
  } else {
    if (permissions.can_facilitate) {
      return [LEARN, TEACH] // <PathModeControls /> depends on order ... great design I know
    } else if (permissions.can_access) {
      return [LEARN]
    }
  }

  return []
}

const stores = [
  {
    store: "path",
    watch: ["viewing_as_learner"]
  },
  {
    store: "resource",
    watch: ["resource", "offering", "registration"]
  }
]

// Unable to export a function that accepts a composeable component as each use overrides the previous reference of the composed component.
// Notied this before some time ago but still unable to pinpoint the root case. Have to use the default export as an inline component.
export default (Component) =>
  ConnectStores(
    Component,
    stores,
    {},
    (state, ownProps) => {
      const { offering, registration } = state.resourceStore.state
      let { viewing_as_learner } = state.pathStore.state
      const permissions = state.resourceStore.request.permissions()

      // Allow overriding viewing_as_learner check.
      if ("viewing_as_learner" in ownProps) {
        viewing_as_learner = ownProps.viewing_as_learner
      }

      return {
        availableModes: getAvailableModes({
          permissions,
          offering,
          registration,
          viewing_as_learner
        }),
        ...ownProps
      }
    },
    false
  )
